import { template as template_045b9d4b46f14f40906e4e37a4930367 } from "@ember/template-compiler";
import AttachTooltip from 'ember-attacher/components/attach-tooltip';
import svgJar from 'ember-svg-jar/helpers/svg-jar';
import t from 'ember-intl/helpers/t';
export default template_045b9d4b46f14f40906e4e37a4930367(`
  <span class="tooltip-wrapper" aria-label={{t "shared.accessibility.helpLabel"}}>
    {{svgJar "help" class="icon" aria-hidden="true"}}
    <AttachTooltip @class="tooltip align-left">
      {{yield}}
    </AttachTooltip>
  </span>
`, {
    eval () {
        return eval(arguments[0]);
    }
});
